import React from "react";
interface props {
  className?: string;
}

function Icon6({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 43"
    >
      <circle cx="21" cy="21.059" r="20.5" stroke="#FF752C"></circle>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.218 14.609l-1.324-2.39-6.546 4.228m13.16 0l-2.143-3.87-5.992 3.87m10.642 9.697v2.119a1.513 1.513 0 01-1.51 1.517H13.267a1.514 1.514 0 01-1.516-1.51V17.964a1.51 1.51 0 011.51-1.517h14.239a1.515 1.515 0 011.516 1.51v2.432m-2.643 2.896a1.023 1.023 0 11-2.046 0 1.023 1.023 0 012.046 0zm-1.27 2.902c-1.614 0-2.915-1.284-2.915-2.878 0-1.595 1.3-2.878 2.916-2.878l4.563-.049c.325 0 .584.26.584.583v4.59c0 .324-.26.584-.583.584l-4.565.048z"
      ></path>
    </svg>
  );
}

export default Icon6;
